<template>
  <card>
    <list
      v-if="$store.state.user.sections['certificates']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setImport="true"
      :setLink="setLink"
      :staticFilters="staticFilters"
      :openItem="true"
      :fields="fields"
      :exportFields="exportFields"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
      :projectInfo="6"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      staticFilters: [
        {
          title: "Фильтр по статусу",
          key: "state",
          default: "0",
          items: [
            {
              id: "0",
              title: "Показать все",
            },
            {
              id: "cancel",
              title: "Отменен",
            },
            {
              id: "new",
              title: "В процессе",
            },
            {
              id: "sent",
              title: "Выполнено",
            },
          ],
        },
      ],
      //ID	Номер сертификата 	Наименование смартфона	IMEI	Цена сертификата Keep Talk	Услуга оформления	Локация	ФИО сотрудника	Дата формирование 	Дата выдачи сертификата 	Статус заявки	ФИО Абонента
      exportFields: {
        ID: {
          field: "id",
          callback: (value) => {
            return value;
          },
        },
        "Номер сертификата": {
          field: "exchange_id",
          callback: (value) => {
            return value;
          },
        },
        "Наименование смартфона": {
          field: "name",
          callback: (value) => {
            return value;
          },
        },
        IMEI: {
          field: "code",
          callback: (value) => {
            return value;
          },
        },
        "Цена сертификата": {
          field: "price_partner",
          callback: (value) => {
            return value;
          },
        },
        "Услуга оформления": {
          field: "price",
          callback: (value) => {
            return value;
          },
        },
        Локация: {
          field: "shop.name",
          callback: (value) => {
            return value;
          },
        },
        "ФИО сотрудника": {
          field: "user.name",
          callback: (value) => {
            return value;
          },
        },
        "Дата формирования": {
          field: "created_at",
          callback: (value) => {
            return value;
          },
        },
        Статус: {
          field: "display_status",
          callback: (value) => {
            return value;
          },
        },
        "Имя абонента": {
          field: "client.first_name",
          callback: (value) => {
            return value;
          },
        },
        "Фамилия абонента": {
          field: "client.last_name",
          callback: (value) => {
            return value;
          },
        },
        "Отчество абонента": {
          field: "client.family_name",
          callback: (value) => {
            return value;
          },
        },
      },
      params: {},
      val: [],
      modalCreate: "dealer",
      fields: [
        {
          label: "Номер телефона",
          key: "phone",
          labelKey: "phone",
          type: "mask",
          mask: "+998#########",
          default: "+998",
        },
        {
          col: " col-12 col-md-6",
          label: "Имя клиента",
          key: "first_name",
          labelKey: "first_name",
          type: "field",
        },
        {
          col: " col-12 col-md-6",
          label: "Фамилия клиента",
          key: "last_name",
          labelKey: "last_name",
          type: "field",
        },
        {
          col: " col-12 col-md-6",
          label: "ПИНФЛ",
          key: "PINFL",
          labelKey: "PINFL",
          type: "field",
        },

        {
          label: "Товар",
          key: "variant",
          labelKey: "product",
          type: "select",
          modal: "variant",
          selectKey: "name",
        },
        {
          label: "IMEI",
          key: "code",
          labelKey: "imei",
          type: "field",
          textType: "text",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_certificate",
      itemLink: "certificates",
      setLink: "certificates",
      columns: [
        {
          detail: true,
        },
        {
          key: "id",
          title: "ID",
        },
        {
          key: "display_status",
          title: "Статус",
        },
        {
          key: "client",
          object: "first_name",
          title: "Имя абонента",
          disableLink: true,
        },
        {
          key: "client",
          object: "last_name",
          title: "Фамилия абонента",
          disableLink: true,
        },
        {
          key: "client",
          object: "PINFL",
          title: "PINFL",
          disableLink: true,
        },
        {
          key: "exchange_id",
          titleKey: "cert",
          title: "Сертификат",
        },

        {
          key: "name",
          titleKey: "product",
          title: "Товар",
          disableLink: true,
          full: true,
        },
        {
          key: "barcode",
          titleKey: "barcode",
          title: "Баркод",
          disableLink: true,
        },
        {
          key: "price_variant",
          titleKey: "Цена товара",
          title: "Цена товара",
          full: true,
        },
        {
          key: "code",
          titleKey: "IMEI",
          title: "IMEI",
          disableLink: true,
          full: true,
        },
        {
          key: "shop",
          titleKey: "shop",
          title: "Магазин",
          object: "name",
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "price",
          titleKey: "Услуга оформления",
          title: "Услуга оформления",
        },
        {
          key: "price_partner",
          titleKey: "Цена сертификата",
          title: "Цена сертификата",
        },
        {
          key: "price_compensation",
          titleKey: "Стоимость компенсации (0 если не было запроса)",
          title: "Стоимость компенсации (0 если не было запроса)",
        },
        {
          key: "user",
          object: "name",
          titleKey: "Оператор",
          title: "Оператор",
          disableLink: true,
        },
        {
          key: "user",
          object: "phone",
          titleKey: "Номер оператора",
          title: "Номер оператора",
          disableLink: true,
        },
        {
          key: "created_at",
          titleKey: "Дата создания",
          title: "Дата создания",
        },
      ],
    };
  },
};
</script>
<style>
</style>
